import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import ButtonTable from '../common/table/buttonTable';

import { setModoTela, initForm, getListaSugestao } from './manutencaoItemActions';

class ManutencaoItemForm extends Component {

	state = {
		sugestoesFiltradas: [],
		mostrarSugestoes: false
	};

	componentWillMount() {
		this.props.getListaSugestao();
	}

	filtrarSugestoes = (valor) => {

		if (!valor) {
			this.setState({
				sugestoesFiltradas: [],
				mostrarSugestoes: false
			});

			return;
		}

		const texto = valor.toLowerCase();

		const sugestoes = (this.props.listaSugestao || []).filter(item => {

			const descricao = (item.descricao || '').toLowerCase();

			const palavrasBusca = texto.split(' ').filter(Boolean);

			return palavrasBusca.some(palavra =>
				descricao.includes(palavra)
			);

		}).slice(0, 8);

		this.setState({
			sugestoesFiltradas: sugestoes,
			mostrarSugestoes: true
		});
	};

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Grid cols='12 12 12 12'>
								<Field
									name='id_veiculo'
									component={Select}
									options={this.props.listaVeiculo}
									label='Veículo'
									cols='12 12 12 12'
									placeholder='Selecione o veículo'
									readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />

								<Field
									name='id_manutencao_area'
									component={Select}
									options={this.props.listaManutencaoArea}
									label='Manutenção'
									cols='12 12 12 12'
									placeholder='Selecione'
									readOnly={readOnly} />
							</Grid>

							<Grid cols='12 12 12 12'>
								
								<div style={{ position: 'relative' }}>

									<Field
										name='descricao'
										component={LabelAndInput}
										label='Descrição do Problema'
										placeholder='Informe a descrição'
										readOnly={readOnly}
										autoComplete='off'
										onChange={(e) => {

											const valor = e.target.value;

											this.filtrarSugestoes(valor);
										}}
										onBlur={() => {

											setTimeout(() => {

												this.setState({
													mostrarSugestoes: false
												});

											}, 150);
										}}
										onFocus={(e) => {

											if (e.target.value) {
												this.filtrarSugestoes(e.target.value);
											}
										}}
									/>

									{this.state.mostrarSugestoes && (
										<div
											style={{
												position: 'absolute',
												top: 72,
												left: 0,
												right: 0,
												backgroundColor: '#fff',
												border: '1px solid #ddd',
												borderRadius: 8,
												boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
												zIndex: 999,
												maxHeight: 250,
												overflowY: 'auto'
											}}
										>

											{this.state.sugestoesFiltradas.map((item, index) => (
												<div
													key={index}
													onMouseDown={() => {

														this.props.change(
															'descricao',
															item.descricao
														);

														this.setState({
															mostrarSugestoes: false
														});
													}}
													style={{
														padding: 12,
														cursor: 'pointer',
														borderBottom: '1px solid #f1f1f1'
													}}
												>
													<i className='fa fa-wrench'></i>
													{' '}
													{item.descricao}
												</div>
											))}

										</div>
									)}

								</div>

							</Grid>

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
		)
	}


}

ManutencaoItemForm = reduxForm({ form: 'manutencaoItemForm', destroyOnUnmount: false })(ManutencaoItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.manutencaoItem,
	formularioValues: getFormValues('manutencaoItemForm')(state),
	registro: state.manutencaoItem.registro,
	listaVeiculo: state.manutencaoItem.listaVeiculo,
	listaManutencaoArea: state.manutencaoItem.listaManutencaoArea,
	listaSugestao: state.manutencaoItem.listaSugestao
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, getListaSugestao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ManutencaoItemForm);
